import api from "./api";

/* =========================
   PAYMENTS
========================= */

export const getPayments = () => {
  return api.get("/accounting/payments");
};

export const createPayment = (data) => {
  return api.post("/accounting/payments", data);
};


/* =========================
   EXPENSES (ERP ENGINE)
========================= */

// ✅ GET (correct)
export const getExpenses = (params) => {
  return api.get("/expenses", { params });
};

// ✅ GET SINGLE
export const getExpenseById = (id) => {
  return api.get(`/expenses/${id}`);
};

// ❌ FIXED (was wrong)
export const createExpense = (data) => {
  return api.post("/expenses", data);
};

// ❌ FIXED (was wrong)
export const payExpense = (data) => {
  return api.post("/expenses/pay", data);
};

// ❌ FIXED (was wrong)
export const payMultipleExpenses = (data) => {
  return api.post("/expenses/pay-multiple", data);
};

// ❌ FIXED (was wrong)
export const paySelectedExpenses = (data) => {
  return api.post("/expenses/pay-selected", data);
};


/* =========================
   PAYABLES (VENDOR BILLS)
========================= */
/* =========================
   PAYABLES (VENDOR BILLS)
========================= */

export const getVendorBills = (params) => {
  return api.get("/vendor-invoices", { params });
};

export const getVendorBillById = (id) => {
  return api.get(`/vendor-invoices/${id}`);
};

export const createVendorBill = (data) => {
  return api.post("/vendor-invoices", data);
};

export const cancelVendorBill = (id) => {
  return api.post(`/vendor-invoices/${id}/cancel`);
};

/* =========================
   RECEIVABLES (INVOICES)
========================= */

export const getReceivables = (params) => {
  return api.get("/accounting/receivables", { params });
};


/* =========================
   CHART OF ACCOUNTS
========================= */

export const getAccounts = () => {
  return api.get("/accounting/accounts");
};

export const createAccount = (data) => {
  return api.post("/accounting/accounts", data);
};


/* =========================
   REPORTS
========================= */

// ❌ FIXED (your routes are NOT /reports/*)

export const getTrialBalance = () => {
  return api.get("/accounting/trial-balance");
};

export const getProfitLoss = () => {
  return api.get("/accounting/profit-loss");
};

export const getBalanceSheet = () => {
  return api.get("/accounting/balance-sheet");
};